import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class VODFatherUtilities extends AbstractTagClass {
    constructor(argument) {
        super({
            name: 'VODFatherUtilities',
            ...argument
        });
    }
    hasFeatureFlag(params = this.tag?.params) {
        return params?.AD?.vodf === true;
    }
    isVOD(params = this.tag?.params, metadata = this.apiMetadata) {
        return !this.tag?.model?.contentUtilities?.isLive(params, metadata);
    }
    isEnabled(params = this.tag?.params, metadata = this.apiMetadata) {
        return (this.isVOD(params, metadata) &&
            this.hasFeatureFlag());
    }
    getDaiCmsId(params = this.tag?.params) {
        return this.tag?.millstoneUtilities?.getDaiCmsId(params);
    }
}
